export const FormLabel = {
  baseStyle: {
    fontSize: 'sm',
    fontWeight: '500',
    lineHeight: '2xl',
    color: 'black.600',
    _dark: { color: 'white' },
  },
}
